/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-target-blank */
import React, { useState, useEffect } from "react";
import GitService from "../../services/gitlab";

export default function OpenedMergeRequests({ projectId }) {
  const [mergeRequests, getMRs] = useState([]);

  const getAllMergeRequests = () => {
    GitService.getMergeRequests(projectId, "opened").then((response) => {
      getMRs(response.data);
    });
  };

  useEffect(() => {
    getAllMergeRequests();
  }, []);

  return (
    <details className="card" open={!!mergeRequests.length}>
      <summary className="card-header">
        <h5 className="h3 card-title">{`Open Merge Requests (${mergeRequests.length})`}</h5>
      </summary>
      <div className="card-body">
        {mergeRequests.length === 0 ? (
          <div className="callout callout-info text-center">
            No open merge requests found.
          </div>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Owner</th>
                <th>Name</th>
                <th>Reviewers</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {mergeRequests.slice(0, 5).map((mergeRequest) => {
                return (
                  <tr key={mergeRequest.id}>
                    <td>{mergeRequest.author.name}</td>
                    <td>{mergeRequest.title}</td>

                    <td>
                      {mergeRequest.reviewers.length > 0 &&
                        mergeRequest.reviewers.map((reviewer) => {
                          return <p key={reviewer.id}>{reviewer.name}</p>;
                        })}
                    </td>
                    <td className="">
                      <a
                        target="_blank"
                        href={mergeRequest.web_url}
                        className="btn btn-sm btn-primary"
                      >
                        <i className="uil uil-globe"></i>
                        Url
                      </a>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </details>
  );
}
